import Helper from '@/utils/helper'
import Cookies from 'js-cookie'
import LoadingGuiManager from '@/app/mixins/loading-gui-manager'
import { mapActions, mapState } from 'vuex'
import * as types from '@/store/types'

export default {
  mixins: [LoadingGuiManager],
  data () {
    return {
      resetAuthForm: false,
      visibleAuthForm: false,
      errorSubmit: null
    }
  },
  computed: {
    ...mapState({
      sessionInit: state => state.session.init
    })
  },
  methods: {
    ...mapActions({
      sessionSet: types.SESSION.set,
      sessionReset: types.SESSION.reset,
      headerStateSet: types.GUI.header.set
    }),
    autoAuth (id, key, viewportWidth, viewportInitialScale, shrinkToFit) {
      if (id && key) {
        const params = {}
        if (viewportWidth !== undefined) {
          params.viewportWidth = viewportWidth
        }
        if (viewportInitialScale !== undefined) {
          params.viewportInitialScale = viewportInitialScale
        }
        if (shrinkToFit !== undefined) {
          params.shrinkToFit = shrinkToFit
        }

        this.logout(id, key, params)
      }
    },
    auth ({ login, password }, params = {}, autoLogin = false) {
      this.setLoadingGui()
      this.$service.login(login, password)
        .then(({ uuid, id, idBranch }) => {
          Cookies.set('userData', {
            uuid,
            id,
            idBranch
          }, { expires: 365 })
          this.setScreenData(params)
          this.sessionSet()
          this.hideAuthForm()
          this.$pageManager.showTableSettings()
        })
        .catch((e) => {
          this.errorSubmit = e
          if (e.isKnown() && autoLogin) {
            alert(`${e.message}\n${e.description}`)
          }
        })
        .finally(() => {
          this.unsetLoadingGui()
        })
    },
    logout (afterLogin, afterPassword, afterParams) {
      this.setLoadingGui()
      this.$service.logout()
        .catch((e) => {
          // do noting
        })
        .finally(() => {
          Cookies.remove('userData')
          this.sessionReset()
          this.hideAuthForm()
          this.$pageManager.showLogin()
          this.unsetLoadingGui()
          if (afterLogin && afterPassword) {
            this.auth({
              login: afterLogin,
              password: afterPassword
            }, afterParams, true)
          }
        })
    },
    hideAuthForm () {
      this.visibleAuthForm = false
      this.errorSubmit = null
      this.resetAuthForm = true
    },
    showAuthForm () {
      this.visibleAuthForm = true
      this.resetAuthForm = false
    },
    setScreenData (data) {
      const params = {}
      if (data?.viewportWidth !== undefined) {
        params.viewportWidth = data.viewportWidth
      }
      if (data?.viewportInitialScale !== undefined) {
        params.viewportInitialScale = data.viewportInitialScale
      }
      if (data?.shrinkToFit !== undefined) {
        params.shrinkToFit = data?.shrinkToFit
      }
      if (Object.keys(params).length > 0) {
        Cookies.set('screenData', {
          params
        }, { expires: 365 })
      }
    }
  },
  mounted () {
    if (Helper.isDefined(Cookies.get('userData'))) {
      this.sessionSet()
    }
  }
}
